import React, { useState, useRef, useEffect } from "react";
import { DataTableBase } from "@reusejs/react";
import { useRouter } from "next/router";
import { getTeamMembers, getTeamMembersWithPagination } from "services";
import { useSelector } from "react-redux";

export default function BankerTeams() {
  const router = useRouter();
  const tableRef = useRef<any>(null);

  const currentBranch = useSelector((state: any) => {
    return state.bankerAuth.currentBranch;
  });
  const [config, setConfig] = useState<any>({
    filterable: false,
    columns: [
      {
        label: "UUID",
        identifier: "uuid",
        resolver: (d: any) => {
          return d["uuid"];
        },
        sortable: false,
        filterable: false,
      },
      {
        label: "Email",
        identifier: "email",
        resolver: (d: any) => {
          return d["attributes"][0]?.value ? d["attributes"][0]?.value : "NA";
        },
        sortable: false,
        filterable: {
          type: "text",
        },
      },
      {
        label: "Role",
        identifier: "role",
        resolver: (d: any) => {
          return d["permissions"].role ? d["permissions"].role : "NA";
        },
        sortable: false,
        filterable: false,
      },
    ],
  });

  useEffect(() => {
    if (tableRef && tableRef.current) {
      tableRef?.current?.refresh();
    }
  }, [currentBranch]);

  const dataSource = async (params: any) => {
    console.log("params::>", params);

    let limitBy: any = {};
    limitBy["per_page"] = params.per_page;
    limitBy["page"] = params.page;
    let response: any = await getTeamMembersWithPagination(
      limitBy,
      currentBranch?.team["teams*uuid"]
    );
    console.log("response::>", response);
    let data = response.data;
    return {
      data: data,
      pagination: {
        total: response.meta.total,
      },
    };
  };

  return (
    <div className="w-full p-6 flex flex-col justify-center">
      <div className="min-w-full flex justify-between">
        <div className="w-1/2 text-4xl text-blue-600 font-extrabold">Teams</div>
      </div>
      <div className="mt-4">
        <DataTableBase
          ref={tableRef}
          sortColumn={0}
          sortOrder={"asc"}
          dataSource={dataSource}
          perPage={10}
          config={config}
        />
      </div>
    </div>
  );
}
